hasSelection = require 'lib/util/selection/has-selection'
React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_member_item_component')

module.exports = class extends React.Component
  # The definitive source of truth for all state is the Renderable object,
  # we use React's state just as a way to trigger re-rendering. Keep in sync
  # with the Renderable at all times.
  constructor: (props) ->
    super(props)

    @state = {
      selected: @props.item.selected
    }

  render: t.renderable ->
    { eventHandlers, item } = @props
    {
      initials
      fullName
      username
      avatarDomain
      avatarHash
      type
      isDeactivated
      hasTransferred
      selected
      enterpriseOrgCount
      reloading
      isMe
    } = item

    t.div '.dashboard-list-item.dashboard-list-selectable.u-clearfix.dashboard-item-hoverable',
      class: t.classify('multiple-select-state-selected': selected)
      onMouseDown: (e) =>
        # Block text selection with shift so we can use it for item ranges
        if e.shiftKey
          e.preventDefault()
      onClick: (e) =>
        # If they've just selected text they're probably trying to copy a
        # member name, not select that member
        if hasSelection() && !e.shiftKey
          return
        item.selected = !item.selected
        @setState(selected: item.selected)
        eventHandlers.onSelectCheckboxClick(item, selectRange: e.shiftKey)
    , =>
      t.div '.multiple-select-checkbox', ->
        t.icon 'check', class: 'multiple-select-checkbox-check'

      t.div '.member .member-no-menu',
        { class: t.classify('member-deactivated': isDeactivated) }
      , ->
        if avatarHash
          t.img '.member-avatar', {
            height: '32',
            width: '32',
            src: [avatarDomain, avatarHash, '50.png'].join('/')
            srcSet: [avatarDomain, avatarHash, '50.png 1x'].join('/') + ', ' + [avatarDomain, avatarHash, '50.png 2x'].join('/')
            alt: fullName + " (" + username + ")",
            title: fullName + " (" + username + ")"
          }

        else
          t.span '.member-initials', { title: fullName + " (" + username + ")" }, ->
            t.text initials

      t.div '.details', ->
        t.p '.name-line', ->
          t.span '.full-name', ->
            t.text fullName

        t.p '.u-bottom.quiet', ->
          if username
            t.span '.quiet.u-inline-block', ->
              t.format 'at-username', { username: username }

      t.div '.options', =>
        if type?
          t.p '.option.status.quiet', ->
            t.format type
        if isDeactivated
          t.p '.option.status.quiet', ->
            t.format 'deactivated'
        if !hasTransferred
          t.p '.option.status.quiet', ->
            t.format 'not-transferred'

        if enterpriseOrgCount > 0
          t.a '.option.quiet-button.role-button',
            href: '#'
            onClick: (e) ->
              e.stopPropagation()
              e.preventDefault()
              eventHandlers.onPopoverClick(e.currentTarget, item)
          , ->
            t.format 'team-count', count: enterpriseOrgCount
        else
          t.p '.option.status.quiet.no-team', ->
            t.format 'not-in-team'

        if reloading
          t.div '.option.reloading', ->
            t.div '.spinner'
        else
          if isDeactivated
            t.a '.option.quiet-button.role-button',
              class: t.classify('disabled': isMe)
              href: '#'
              onClick: (e) =>
                e.stopPropagation()
                e.preventDefault()
                if !isMe
                  eventHandlers.onReactivateClick(e.currentTarget, item)
            , ->
              t.text 'Reactivate'
          else
            t.a '.option.button-link.role-button',
              class: t.classify('disabled': isMe)
              href: '#'
              onClick: (e) =>
                e.stopPropagation()
                e.preventDefault()
                if !isMe
                  eventHandlers.onDeactivateClick(e.currentTarget, item)
            , ->
              t.text 'Deactivate'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/member-item-component.coffee